// extracted by mini-css-extract-plugin
export default {"container":"for_23iPG","inner":"for_inn_3FhrX","label":"for_lab_2ee_k","heading":"for_hea_1S_GH"};